var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail-tracking',{attrs:{"data":_vm.data,"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }